export interface MediaImage {
  id?: string;
  imageName?: string;
  imagePath?: string;
  imageType?: PictureTypeEnum;
  imageRedirectLink?: string
}


export enum PictureTypeEnum {
  BANNER = 'BANNER',
  CAROUSEL = 'CAROUSEL',
  NEWS = 'NEWS'
}
